import $        from "jquery"
import select2  from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

export default function() {
  $(".select2").select2({
    placeholder: 'Select',
    theme: "bootstrap",
  }).on('change', (e) => {
    controller.emit('select2-changed', this)
  })

  $(".multi-select2").select2({
    placeholder: 'Select any option',
    multiple: true,
    theme: "bootstrap",
  }).on('change', (e) => {
    controller.emit('select2-changed', this)
  })


  // Designed that when changed, triggers the form submission
  $(".auto-submit-select2").select2({
    placeholder: 'Select',
    allowClear: true,
    theme: "bootstrap",
  }).on('change', (e) => {
    let form = $(e.target).parents('form')
    $.get(form.attr("action"), form.serialize(), null, "script")
    controller.emit('select2-changed', this)
  })
}
